// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m-comment__text[data-v-0bc26de9] {\n  font-size: 13px;\n}\n", ""]);
// Exports
module.exports = exports;
